import { isEmpty } from 'lodash';

import { HTTP_METHOD_POST } from '../../constants/httpMethod';
import { REQUEST_ENROLLMENT, SUCCESS_ENROLLMENT, FAILURE_ENROLLMENT } from './constants';

import { updateInfos } from '../account/actions';
import { forceFetchPartners } from '../partner/actions';

import { CALL_API } from '../../middlewares/api';

export const ERROR_FORMDATA_EMPTY = 'formData param must not be empty or null or undefined !';

export function sendEnrollmentRequest(formData, callback) {
    if (isEmpty(formData)) {
        throw new Error(ERROR_FORMDATA_EMPTY);
    }
    return {
        [CALL_API]: {
            endpoint: '/auth/register/enroll',
            method: HTTP_METHOD_POST,
            body: formData,
            types: [REQUEST_ENROLLMENT, SUCCESS_ENROLLMENT, FAILURE_ENROLLMENT],
            successCallback: (response, dispatch) => {
                dispatch(updateInfos(response.payload.user));
                dispatch(forceFetchPartners());
                if (callback) {
                    callback();
                }
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/enrollment/actions.js